import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

// Section 1
const DATE = 'date'
const ELIGIBLE = 'eligible'
const DETAILS = 'details'

const today = new Date()
today.setHours(0, 0, 0, 0)

/**
 * Form model
 */
const formModel = () => {
  return {
    [DATE]: {
      label: `Date`,
      name: DATE,
      required: true,
    },
    [ELIGIBLE]: {
      label: `Eligible`,
      name: ELIGIBLE,
    },
    [DETAILS]: {
      label: `Details`,
      name: DETAILS,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [DATE]: null,
  [ELIGIBLE]: false,
  [DETAILS]: '',
}


export default formModel
